<template>
  <div class="my-2 px-2 container mx-auto max-w-4xl xl:max-w-6xl">
    <TopMenu />
    <main class="p-1 md:p-2 mt-2 md:mt-5 mx-auto">
      <slot />
    </main>
    <FooterMain />    
  </div>
</template>